import React from 'react'
import close from '../../assets/images/close.svg'

const AddNewSubscriber = (props) => {
    return (
        <div>
            {props?.isNewUserCreate && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box add-new-user add-new-customer" ref={props?.refrence}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => props?.setIsNewUserCreate(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>Add New Subscriber</div>
                        <div className="popup-form">
                            <div className="form-group" >
                                <label>Name</label>
                                <input
                                    className='form-input'
                                    name='name'
                                    value={props?.formData?.name}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder='Enter Name'
                                />
                                {props?.errorMessage?.name && <p className='error-message'>{props?.errorMessage?.name}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Location (Optional)</label>
                                <input
                                    className='form-input'
                                    name='city'
                                    value={props?.formData?.city}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder='Enter location'
                                />
                                {props?.errorMessage?.city && <p className='error-message'>{props?.errorMessage?.city}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Mobile Number</label>
                                <input
                                    className='form-input'
                                    name='mobileNumber'
                                    value={props?.formData?.mobileNumber}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder='Enter Mobile Number'
                                />
                                {props?.errorMessage?.mobileNumber && <p className='error-message'>{props?.errorMessage?.mobileNumber}</p>}
                            </div>
                            {props?.error !== "" && props?.error && <p className='error-message'>{props?.error}</p>}
                            <div className="popup-actions">
                                <button className="cancel-btn" onClick={() => props?.setIsNewUserCreate(false)}>Cancel</button>
                                <button className="save-btn" onClick={props?.handleSubmit}>
                                    {props?.isLoading ?
                                        <div className={`ringLoader loaderContinue`}></div>
                                        :
                                        'Save'
                                    }
                                </button>
                            </div>

                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default AddNewSubscriber
